import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchUserDetails } from "../../firebase/database";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import BatteryCellVoltage from "../../components/batteryCellVoltage/BatteryCellVoltage";
import Grid from "@mui/material/Grid2";
import "./User.css";

const UserStatus = () => {
  let { orderId } = useParams();
  const [lastUpdateTime, setLastUpdateTime] = useState("");
  const [latestValues, setLatestValues] = useState({
    voltage: "N/A",
    capacity: "N/A",
    current: "N/A",
  });
  const [cellVoltages, setCellVoltages] = useState([]);
  const [userDetails, setUserDetails] = useState({}); 

  useEffect(() => {
    fetchUserDetails(
      setCellVoltages,
      setLastUpdateTime,
      setLatestValues,
      orderId,
      setUserDetails
    );
  }, [orderId]);

  return (
    <>
      <Navbar />
      <div className="welcome-container">
        <h1>User Dashboard</h1>
        <p className="last-update">Last updated on: {lastUpdateTime}</p>
        <div className="user-details">
          <p>
            <strong>Name:</strong> {userDetails.name || "N/A"}
          </p>
          <p>
            <strong>Contact:</strong> {userDetails.contact || "N/A"}
          </p>
        </div>
      </div>
      <div className="main-container">
        <Grid container spacing={2}>
          {/* Voltage Chart */}
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <div className="chart-box">
           
            </div>
          </Grid>
          {/* Capacity Chart */}
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <div className="chart-box">
          
            </div>
          </Grid>
          {/* Current Chart */}
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <div className="chart-box">
           
            </div>
          </Grid>
        </Grid>
        <BatteryCellVoltage cellVoltages={cellVoltages} />
      </div>
      <Footer />
    </>
  );
};

export default UserStatus;
